import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { UpdatePaymentScrapTradesPostRequestModel, UpdatePaymentScrapTradesPostResponseModel } from "@/features/accounts/payment/scraping/services/update-trades-model";
import { Timeout } from "@/shared/services/http-client";

export class UpdatePaymentScrapTradesApi {
  /**
   * Look明細更新（サーバ版スクレイピング）API
   */
  public updatePaymentScrapTrades = async (
    param: UpdatePaymentScrapTradesPostRequestModel
  ): Promise<UpdatePaymentScrapTradesPostResponseModel> => {
    const path = `/api/paymentaccounts/scraping/aggregate`;
    const res = await ApiClient.instance.post<UpdatePaymentScrapTradesPostResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
      timeout: Timeout.VeryLong,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
